import React, { FC } from "react";
import { FallbackContainer } from "./styledComponents";

const PlatformsCompatibilityFallback: FC = () => {
  return <FallbackContainer />;
}

export default PlatformsCompatibilityFallback;
